import { useQuery } from "@tanstack/react-query";
import { fetchUserById } from "../services/usersServices";

const useUser = (id) => {
  return useQuery({
    queryKey: ["user", id],
    queryFn: () => fetchUserById(id),
    refetchOnWindowFocus: false, 
  });
};

export default useUser;
